<!-- CreateOrUpdateForm.vue -->
<template>
  <div>
    <!-- <div class="content-wrapper"> -->
      <div class="card card-with-shadow border-0">
        <div class="card-header p-primary bg-transparent">
          <div class="form-group form-group row align-items-center">
            <label class="col-sm-3 mb-0">Choose an action:</label>
            <app-input 
              class="col-sm-9"
              type="radio"
              :list="typeList"
              v-model="action"/>
            <!-- <input type="radio" v-model="action" value="create">Create a new entry</input>
            <input type="radio" v-model="action" value="update">Update existing entry</input> -->
          </div>
        </div>
        <div class="card-body">
          <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form" :data-url="addUrl" method="post">
            <div v-if="action === 'create'">
              <div class="form-group row align-items-center">
                <label for="inputs_name" class="col-sm-3 mb-0">
                  {{ $t("title") }}
                </label>
                <app-input
                    id="inputs_name"
                    class="col-sm-9"
                    type="text"
                    v-model="inputs.name"
                    :required="true"
                />
              </div>
              <div class="form-group row align-items-center">
                <label for="inputs_description" class="col-sm-3 mb-0">
                  {{ $t("description") }}
                </label>
                <app-input
                    id="inputs_description"
                    class="col-sm-9"
                    type="textarea"
                    v-model="inputs.description"
                />
              </div>
            </div>

<!--            <div class="row mt-2 text-right">-->
<!--              <div class="col-md-12">-->
<!--                <button class="btn btn-primary" type="submit" @click.prevent="submit">{{ $t('save') }}</button>-->
<!--              </div>-->
<!--            </div>-->
          </form>
        </div>
      </div>
    <!-- </div> -->

  </div>
</template>

<script>
import { FormMixin } from "../../../../core/mixins/form/FormMixin";
import { axiosGet, axiosPost } from "../../../Helpers/AxiosHelper";
import * as actions from "../../../Config/ApiUrl";
import {NEW_RESPONSE_REVISION, NEW_RESPONSE_SUBMIT} from "../../../Config/ApiUrl";

export default {
  mixins: [FormMixin],
  data() {
    return {
      action: 'create', // Default action
      formTitle: '',
      formDescription: '',
      preloader: false,
      addUrl: actions.NEW_RESPONSE_REVISION,
      inputs: {
        name:'',
      },
      typeList: [
          {
              id: 'create',
              value: 'Create a new entry'
          },
          {
              id: 'update',
              value: 'Update existing entry'
          },
      ],


    };
  },
  computed: {
    selectedForm() {
      return this.$store.state.selectedForm;
    },
  },
  mounted() {
    this.$hub.$on('formSelected', (status) => {
      if (status){
        this.submit()
      }
    })
  // (() => {
  //   this.inputs.name = this.$store.state.saveFormState.formTitle;
  //   this.inputs.description = this.$store.state.saveFormState.formDescription;
  // })();
    this.inputs.name = this.$store.state.sharedData.sharedData.selectedFormText;
  },

  methods: {
    beforeSubmit(){
      this.preloader = true;

      this.inputs.form_revision_id = this.$store.state.saveFormState.selectedFormRevisionId;
    },
    submit(){
      if (!this.$store.state.saveFormState.formBodyId){

        this.inputs.type = this.action;

        this.save(this.inputs);

      }else{
        this.$emit('next');
      }
    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);
      if (res.data.formRevision){
        this.$store.commit('setFormRevisionId', res.data.formRevision.id);
        this.$store.commit('setFormId', res.data.formRevision.form_id);
        this.$store.commit('setFormBodyId', res.data.formRevision.form_body_id);
      }
    },
    afterFinalResponse() {
      this.preloader = false;
      this.$hub.$emit("canProceed", true);
      this.nextStep();
    },
    nextStep() {
      this.$store.commit('setFormTitle', this.inputs.name);
      this.$store.commit('setFormDescription', this.inputs.description);
      this.$emit('next');
    },
  },
};
</script>
